<template>
   <div v-if="store.state.fullpath == 'no'" class="message_body">
        <div>
            <view315Title :show-exam-btn="false" title="地点上报" @backEvent="backEvent" v-if="!store.state.isH5"></view315Title>
        </div>
        <div style="height: 44px;background: #FFFBE8;" v-if="store.state.isInternalUser || store.state.isStaff">
            <nut-noticebar :background="`rgba(251, 248, 220, 1)`" :color="`#FF8400`" wrapable :scrollable="false"  
            text="腾讯员工不支付酬劳。一张好图，由您贡献~" 
            left-icon="https://img13.360buyimg.com/imagetools/jfs/t1/72082/2/3006/1197/5d130c8dE1c71bcd6/e48a3b60804c9775.png" >
            </nut-noticebar>
        </div>
        <div class="message_type_header">请选择您上报的信息类型</div>
        <div v-for="item in newAddLocationListComputed" :key="item.value" :class="item.className">
            <nut-cell @click="nutCellClick(item)">
                <template v-slot:default>
                    <div style="font-family:Arial, Helvetica, sans-serif;">
                        <img class="nut-icon" :src="item.icon" />
                        <span  :class="['nut-title', item.title ? 'nut-title-mgtp' : '']">
                            <span>{{ item.label }}</span>
                            <span v-if="item.title">{{ item.title }}</span>
                        </span>
                        <img class="nut_title_icon" :src="type_jiantou" alt />
                    </div>
                </template>
            </nut-cell>
        </div>
        <div v-if="!store.state.isInternalUser || store.state.isStaff" class="no_report">
            暂无法上报
        </div>
        <div @click="goToHistory" class="message_type_footer">我的上报记录</div>
   </div>
   <div v-if="store.state.fullpath != 'no'"></div>
</template>
<script setup>
import { onMounted, reactive, computed, getCurrentInstance, onBeforeMount } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from "vuex";
import { newAddLocationList, type_jiantou, staff_config } from '../config'
import view315Title from '../../components/view315Title.vue'
import { Toast } from '@nutui/nutui'

const easyearn = window.easyearn;

const { beacon } = getCurrentInstance().appContext.config.globalProperties;

const store = useStore();
const router = useRouter();
const route = useRoute()

const data = reactive({
    newAddLocationList,
    type_jiantou,
    staff_config,
})
onBeforeMount(() => {
    if (store.state.isH5 && store.state.fullpath != 'no') {
        // data.messageTypeLists = config.message_appear_type_listsh5;
        const rt = JSON.parse(localStorage.getItem('data'))
        console.log(rt, 'JSON.parse(localStorage.getItem(data))');
        if(rt.pageType == 4) {
          nutCellClick(staff_config[0])
        } else {
            nutCellClick(newAddLocationList[rt.pageType * 1 - 1])
        }
        // if(store.state.fullpath != 'no' && rt.title == '道路报错') {
        // }
        // if(store.state.fullpath != 'no' && rt.title.indexOf('地点') > -1) {
        //   nutCellClick(data.messageTypeLists[2])
        // }
      }
})
onMounted(() => {
    store.dispatch('setIsInternalUser')
})
const newAddLocationListComputed = computed(() => {
    let list = []
    if(store.state.isInternalUser != null){
        console.log(store.state.isStaff, 'isStaff');
        if(store.state.isInternalUser || store.state.userInfnewAddLocationListo == 'oA9LiwOVHRl63Ax_H19o7jQ0O8Xo' || store.state.isStaff){
            // 内部用户逻辑
            // list = [...data.staff_config, ...data.newAddLocationList]
            list = [...data.staff_config, ...data.newAddLocationList]
        }else{
            // list = data.newAddLocationList
            list = []
        }
        // if (store.state.isH5) {
        //     list = data.staff_config
        // }
    }
    return list
}, [store.state.isInternalUser])
const goToHistory = () => {
    beacon.onUserAction("record_click");
    router.push("/message_appear_history");
};


const nutCellClick = (item) => {
    if (easyearn && easyearn.getVersionCode() < 32900015) {
        console.log(easyearn.getVersionCode(), 999);
        Toast.text('请升级新版本体验')
        return;
    }
    if(item.value == 4){
        router.push({
            name: "staffReport",
            params: {
                name: JSON.stringify(item),
                from: "index"
            }
        });
        return
    }else{
        router.push({
            path: '/add_location_detail',
            query: {
                value: item.value,
                mapTitle: item.userSelectLatLngTitle,
                from: 'index',
            }
        })
    }
}

// 返回首页
const backEvent = () => {
    if(route.query.normalEntry){
        router.go(-1)
    }else{
        window.easyearn.goMainEntryPage()
        // goBack goMainEntryPage
    }
}

</script>
<style lang='scss' scoped>
.message_type_header {
    opacity: 0.9;
    font-family: NotoSansCJKsc-Medium;
    font-weight: 600;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
    margin: 47px 0 27px 25px;
}
.message_type_header_notice {
    display: flex;
    align-items: center;/*垂直居中*/

}
.messageTypeLists {
    margin: 5px 10px;
    position: relative;
    box-shadow: 0 1px 12px 0 rgba(0, 0, 0, 0.02);
    & img {
        width: 48px;
        height: 48px;
        margin-right: 12px;
    }
    & :deep(.nut-cell) {
        border-radius: 20px;
        padding: 20px 0 20px 20px;
    }
    & :deep(.nut-cell__title) {
        font-family: NotoSansCJKsc-Regular;
        font-weight: 400;
        font-size: 18px;
        color: #000000;
    }
    & .nut-icon {
        display: inline-block;
        vertical-align: middle;
    }
    & .nut-title {
        display: inline-block;
        vertical-align: middle;
        color: #000000;
        span{
            display: block;
        }
        & span:nth-child(1){
            font-size: 18px;
        }
        & span:nth-child(2){
            font-size: 12px;
            margin-top: 2px;
            opacity: 0.5;
            font-weight: 400;
        }
    }
    .nut-title-mgtp{
        margin-top: 5px;
    }
    & .nut_title_icon {
        top: 38px;
        right: 28px;
        position: absolute;
        width: 7px;
        height: 13px;
    }
}
.message_type_footer {
  width: 100%;
  text-align: center;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  letter-spacing: 0;
  text-align: center;
  position: fixed;
  bottom: 8%;
}
.message_body{
    height: calc(100vh);
}
.no_report {
    text-align: center;
    font-size: 14px;
    color: #999;
    padding: 10px 0;
}
</style>